import { Typography } from '@mui/material'
import Admin from 'api/Admin'
import { useState } from 'react'
import { Col, Row } from 'reactstrap'

export default function FormRow({ label, children, type, options, required, touched, errorText, dynamic, ...props }) {


    return (<Row className={"form-group-input"}>
        <Col md="5">
            <h6 className={required && 'required'}>{label}</h6>
        </Col>

        {dynamic ?
            <Col md="6">
                {type == "s_lov" ?
                    <select {...props}>
                        {children.map(d => <option value={d.value || d}>{d.label || d}</option>)}
                    </select>
                    : type == "file" ?
                        <UploadFile  {...props} />
                        : <input type={type} {...props} />}
            </Col>
            : <Col md="6">
                {children ?
                    children
                    : type == "select" ?
                        <select {...props}>
                            {options?.map(d => <option value={d.value || d}>{d.label || d}</option>)}
                        </select>
                        : type == "textarea" ?
                            <textarea {...props} />
                            : <input type={type} {...props} />}
                {touched && <Typography color={"error"}>{errorText}</Typography>}
            </Col>}
    </Row>
    )
}


const UploadFile = ({ onChange, value: val, name, ...props }) => {

    const [loading, setLoading] = useState(false)

    const handleChange = async (e) => {
        try {
            setLoading(true)
            const formDate = new FormData()
            formDate.append("file", e.target.files[0])
            const res = await Admin.File.upload({ body: formDate })
            const value = res.file
            onChange({ target: { name, value } })
        } catch (error) {
            alert(error.message)
        } finally {
            setLoading(false)
        }
    }

    return <input {...props} type={"file"} accept=".jpg,.jpeg,.png,.pdf" disabled={loading} onChange={handleChange} />
}